module.exports = __webpack_public_path__ + "img/razorpay.21b77e60.png";